import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/home/index.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        meta: {
            title: 'Ucute'
        }
    },
    {
        path: '/who-we-are',
        name: 'who-we-are',
        component: () => import('@/views/who-we-are/index.vue'),
        meta: {
            title: 'Ucute'
        }
    },
    {
        path: '/team',
        name: 'team',
        component: () => import('@/views/team/index.vue'),
        meta: {
            title: 'Ucute'
        }
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('@/views/contact/index.vue'),
        meta: {
            title: 'Ucute'
        }
    },
    {
        path: '/products',
        name: 'products',
        component: () => import('@/views/products/index.vue'),
        meta: {
            title: 'Ucute'
        }
    },
    {
        path: '/products/video/:type',
        name: 'products video',
        component: () => import('@/views/products-video/index.vue'),
        meta: {
            title: 'Ucute'
        }
    },
    {
        path: '/:pathMatch(.*)',
        redirect: '/',
    }
]

const router = new VueRouter({
    mode: 'hash',
    routes,
    scrollBehavior() {
        return {x: 0, y: 0}
    }
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router
